import React, { Component } from "react";

import { Card, Icon, Image, Button } from 'semantic-ui-react'
import { injectIntl, defineMessages, FormattedMessage, } from "react-intl";
import Moment from 'react-moment';

import AnimalIcon from "../../Animals/AnimalIcon/AnimalIcon";
import AnimalBioSmall from "../../Animals/AnimalBioSmall/AnimalBioSmall";
import ReadMoreReact from "read-more-react";

const messages = defineMessages({
    found: {
        id: 'app.story.found',
        defaultMessage: 'I was found!'
    },
    more: {
        id: 'app.general.readMore',
        defaultMessage: '(...read more)'
    }
})

class StoryCardView extends Component {
    state = {
        modalIsOpen: false,
        valueIntoModal: "123456abcdef"
    }

    openModal = () => this.setState({ modalIsopen: true })

    closeModal = () => this.setState({ modalIsopen: false })

    render() {
        const { intl: { formatMessage } } = this.props;
        const { story } = this.props;
        return (
            <Card fluid>

                <Image src={``} wrapped ui={false} />
                <Card.Content>
                    <Card.Header>
    <div style={{"float": "left", "marginRight": "10px"}}><i class="
        fas 
        fa-2x
        fa-dog 
        
        " style={{"color": "rgb(118, 118, 195)"}}></i></div>
                    {this.props.story.tags} 
                    </Card.Header>
                    <Card.Meta>
                        <span className='date'>Generated</span>
                        <span className='date'> <Moment fromNow withTitle titleFormat="D MMM HH:mm">{this.props.story.createdAt}</Moment> </span>
                    </Card.Meta>
                  
                </Card.Content>
                <Card.Content extra>
                    <div className='ui three buttons'>
                        <Button basic color='green'>
                            Download
                        </Button>
                        <Button basic color='blue'>
                            Finetune
                        </Button>
                        <Button basic color='red'>
                            Bad Quality
                        </Button>
                    </div>
                </Card.Content>
            </Card>

        )
    }
}

export default injectIntl(StoryCardView)